export type DSPId =
  | "49262307"
  | "99268"
  | "13285026"
  | "7851192"
  | "316911752"
  | "1330598"
  | "2100357"
  | "746109";

export const DSP_MAPPING: Record<DSPId, string> = {
  "49262307": "YouTube",
  "99268": "Amazon",
  "13285026": "Google Play",
  "7851192": "Pandora",
  "316911752": "JioSaavn",
  "1330598": "Apple Music",
  "2100357": "Deezer",
  "746109": "Spotify",
};
